var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',[_vm._v("Copyright©"+_vm._s(_vm.thisYear)+" Hope Medical. All rights reserved.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }